<div class="spinnerOverLay" *ngIf="show">
    <!-- <i aria-hidden="true" class="fa fa-spinner fa-spin"></i> -->
    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>
